// extracted by mini-css-extract-plugin
export default {"modal":"DrawingSideBar__modal___GTXKK"};